import { computed, unref } from "vue"

export const useAmountDueToday = (total, creditAppliedTotal, installments) => {
	const hasMultipleInstallments = computed(() => {
		const installmentList = unref(installments)
		return Array.isArray(installmentList) && installmentList.length > 1
	})

	const amountDueToday = computed(() => {
		if (hasMultipleInstallments.value) {
			const installmentList = unref(installments)
			return Number(installmentList[0]?.amount || 0)
		}

		return Math.max(Number(unref(total) || 0) - Number(unref(creditAppliedTotal) || 0), 0)
	})

	const shouldShowAmountDue = computed(() => {
		return hasMultipleInstallments.value || Number(unref(creditAppliedTotal) || 0) > 0
	})

	return {
		amountDueToday,
		shouldShowAmountDue,
	}
}
